<template>
    <v-dialog v-model="show" @keydown.esc="$emit('close')" @keydown.enter="onConfirm()" persistent max-width="800">
        <v-card>
            <v-card-text class="ma-0 px-2 text-center font-weight-medium">
                <v-row align="center" justify="center" align-content="space-between" v-if="plug.email == true" no-gutters>
                    <v-col cols="12">
                        Digite o email utilizado para o pagamento.
                    </v-col>
                    <v-col cols="12">
                        <v-text-field type="email" outlined label="Email" v-model="email" :rules="[rules.email]" required @keydown.enter="onConfirm" ref="emailField" hide-details
                            dense />
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" align-content="space-between" class="my-4" v-if="plug.email == true && plug.card == true" no-gutters>
                    <v-col cols="12">
                        <v-divider />
                        OU
                        <v-divider />
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" align-content="space-between" v-if="plug.card == true" no-gutters>
                    <v-col cols="12">
                        Digite os 4 últimos digítos do cartão utilizado.
                    </v-col>
                    <v-col cols="12">
                        <div class="ma-auto position-relative" style="max-width: 300px">
                            <v-otp-input length="4" type="number" v-model="code" @finish="onConfirm" dense />
                        </div>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center" align-content="space-between" class="my-4" no-gutters>
                    <v-col cols="12">
                        <v-alert class="mt-1 mb-0" text color="info">
                            <div class="text-subtitle-1">
                                Carregamento desbloqueado por meio de pagamento.
                                <br>
                                <br>
                                <strong>Para 'Encerrar', precisamos te identificar.</strong>
                            </div>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions class="justify-center">
                <v-btn color="success" @click="onConfirm" style="min-width: 25%;" :disabled="sending">
                    <v-icon dark left>check_circle</v-icon>
                    Confirmar
                </v-btn>
                <v-btn color="error" @click="$emit('close')" style="min-width: 25%;" :disabled="sending">
                    <v-icon dark left>cancel</v-icon>
                    Cancelar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import rules from "@/helpers/rules";

export default {
    name: "StopChargerByCode",

    props: {
        show: {
            type: Boolean,
            required: true,
        },
        charger: {
            required: true,
        },
        chargerName: {
            required: true,
        },
        plug: {
            required: true,
        },
    },

    data() {
        return {
            rules,
            sending: false,
            code: null,
            email: null,
        };
    },

    mounted() {
        if (this.$store.state.payment.email && this.isMaskedEmailMatching(this.plug.userEmail, this.$store.state.payment.email)) {
            this.email = this.$store.state.payment.email;
        }
    },

    methods: {
        onConfirm() {
            if (this.code && this.code.length > 0 && this.code.length != 4) {
                this.$eventHub.$emit("msgError", "Código inválido");
                return;
            }
            if (this.email && this.email.length > 0) {
                const emailField = this.$refs.emailField;
                if (!emailField || !emailField.validate()) {
                    this.$eventHub.$emit("msgError", "Email inválido");
                    return;
                }
            }
            if (!this.code && !this.email) {
                this.$eventHub.$emit("msgError", "Informe o email ou os 4 últimos digítos do cartão utilizado.");
                return;
            }
            this.sending = true;
            this.$http
                .postDynamic(this.charger.server, "api/v2/stopByCode", { charger: this.chargerName, plug: this.plug.plug, code: this.code, email: this.email })
                .then((result) => {
                    if (result && result.unlock == true) {
                        this.$eventHub.$emit("msgSuccess", result && result.message ? result.message : "Enviado com sucesso.");
                        this.$emit("close");
                    } else {
                        this.$eventHub.$emit("msgWarning", result && result.message ? result.message : "Erro ao efetuar comando.");
                    }
                })
                .catch((error) => {
                    this.$eventHub.$emit("msgError", error && error.message ? error.message : "Erro ao enviar, tente novamente.");
                }).finally(() => {
                    this.sending = false;
                });
        },

        isMaskedEmailMatching(maskedEmail, actualEmail) {
            if (maskedEmail && actualEmail) {
                const [maskedLocal, maskedDomain] = maskedEmail.split("@");
                const [actualLocal, actualDomain] = actualEmail.split("@");

                if (!maskedLocal || !maskedDomain || !actualLocal || !actualDomain) {
                    return false;
                }

                const regexify = (str) => new RegExp("^" + str.replace(/\*/g, ".*") + "$");

                const isLocalMatching = regexify(maskedLocal).test(actualLocal);
                const isDomainMatching = regexify(maskedDomain).test(actualDomain);

                return isLocalMatching && isDomainMatching;
            }
            return false;
        },
    },
};
</script>